/**
 * @param {string} phone
 * @returns {string}
 */
export function maskPhoneNumber(phoneNumber) {
  const regex = /^(\d{3})\d{4}(\d{4})$/;
  return phoneNumber.replace(regex, '$1****$2');
}
